import { useAppContext } from 'hooks/useAppContext';
import { useToast } from 'hooks/useToast';

const useShareFreightWithTruckers = () => {
  const {
    state: {
      shareFreights: { truckers },
    },
    dispatch,
  } = useAppContext();
  const { createToast } = useToast();

  const toggleModalShareFreight = () => dispatch({ type: 'toggle_modal_share_freight' });

  const handleShareFreightWithTruckers = () => {
    const isAllTruckersSelectedShared = truckers.every((trucker) => trucker.isShared);
    if (isAllTruckersSelectedShared) {
      createToast({
        severity: 'error',
        heading: 'Não foi possível compartilhar o frete.',
        message: 'Você já compartilhou esse frete com todos os motoristas selecionados.',
      });
    } else {
      toggleModalShareFreight();
    }
  };

  return { toggleModalShareFreight, handleShareFreightWithTruckers };
};

export { useShareFreightWithTruckers };
